__turbopack_context__.v({
  "articleContainer": "BrandValues-module-scss-module__Ss221q__articleContainer",
  "articlesContainer": "BrandValues-module-scss-module__Ss221q__articlesContainer",
  "copy": "BrandValues-module-scss-module__Ss221q__copy",
  "cta": "BrandValues-module-scss-module__Ss221q__cta",
  "fourItems": "BrandValues-module-scss-module__Ss221q__fourItems",
  "hasLink": "BrandValues-module-scss-module__Ss221q__hasLink",
  "heading": "BrandValues-module-scss-module__Ss221q__heading",
  "imageContainer": "BrandValues-module-scss-module__Ss221q__imageContainer",
  "mainHeading": "BrandValues-module-scss-module__Ss221q__mainHeading",
  "threeItems": "BrandValues-module-scss-module__Ss221q__threeItems",
  "twoItems": "BrandValues-module-scss-module__Ss221q__twoItems",
});
